import { render, staticRenderFns } from "./🍣.vue?vue&type=template&id=3f67e72a&scoped=true&lang=pug&"
import script from "./🍣.vue?vue&type=script&lang=ts&"
export * from "./🍣.vue?vue&type=script&lang=ts&"
import style0 from "./🍣.vue?vue&type=style&index=0&id=3f67e72a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f67e72a",
  null
  
)

component.options.__file = "🍣.vue"
export default component.exports